import { TermsType } from '../interface'

const isEnglish = (term: TermsType) =>
	term.language === 'en-US' || term.language === 'en-GB'

export default isEnglish
